import { AppBar, Button, Stack, Toolbar } from '@mui/material';
import { forwardRef, type MouseEventHandler, type ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { primaryBlue, primaryRed } from '../models/colors';
import { AuthService } from '../services/AuthService';
import Logo from './header/allison-logo.svg?react';

const StyledToolbar = styled((props: any) => <Toolbar {...props} />)`
	display: flex;
	justify-content: space-between;
	height: 100px;
	min-height: 72px;
	@media only screen and (max-width: 475px) {
	padding: 16px 0 8px 0;
		flex-direction: column;
	}
`;

type LinkBaseProps = {
	to: string;
	className?: string;
	onClick?: MouseEventHandler<HTMLAnchorElement>;
	children?: ReactNode;
};

const LinkBase = forwardRef<HTMLAnchorElement, LinkBaseProps>(function LinkBase(props, ref) {
	const { to, ...rest } = props;
	return <Link ref={ref} to={to} {...rest} />;
});

type StyledLinkProps = {
	to: string;
	label: string;
    onClick?: MouseEventHandler<HTMLAnchorElement> | MouseEventHandler<HTMLButtonElement> | undefined;
};

const StyledLink = styled(({ label, ...rest }: StyledLinkProps) => (
	<Button
		component={LinkBase}
		variant={`text`}
		sx={{
			fontWeight: 'bold',
			fontSize: '0.8125rem',
			color: primaryRed,
			textTransform: 'none',
			'&:hover': {
				textDecoration: 'underline',
			},
		}}
        {...(rest as any)}
	>
		{label}
	</Button>
))``;

const Spacer = styled('div')`
	height: 40px;
	width: 100%;
	background-color: ${primaryBlue};
`;

export const Header = () => {
	const navigate = useNavigate();
	return (
		<AppBar position="static" style={{ background: '#FFFFFF' }}>
			<Spacer />
			<StyledToolbar>
				<Stack title="Navigate home" direction="row" style={{ cursor: 'pointer' }}>
					<Logo onClick={() => navigate('/')} />
				</Stack>
				<Stack direction="row">
					<StyledLink to="/" label="HOME" />
					{AuthService.isAuth().val
						? (<StyledLink to="/logout" label="LOG OUT" onClick={() => AuthService.logout()} />)
						: null}
					<StyledLink to="/contact" label="CONTACT" />
				</Stack>
			</StyledToolbar>
		</AppBar>
	);
};
